module.exports = "<ul>\n    <li *ngFor=\"let filter of filters\">\n        <a class=\"btn filter\" (click)=\"toggle(filter)\" [ngClass]=\"{'active': filter.isChecked}\">\n            <img class=\"svg-icon\" [src]=\"filter.svg\">\n            <span class=\"over-element middle\">{{filter.name}}</span>\n        </a>\n    </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/filter-panel.component.html
// module id = ../../../../../src/app/common/filter-panel.component.html
// module chunks = main